/* inspried by: https://medium.com/outsystems-experts/javascript-events-unmasked-how-to-create-an-input-mask-for-mobile-fc0df165e8b2,
                https://clark.engineering/input-on-android-229-unidentified-1d92105b9a04 */

import isEmpty from '../utility/isEmpty.js'

/* NOTE:  on Android devices, many keys are returned as key 229 (Unidentified) and when that happens, preventDefault doesn't work.
          Therefore, we can't depend solely on 'keydown'.  We must include 'input' in on the fun.
*/

let keyDownValue = ''
let inputValue = ''
const regex = /[0-9.$]+/

const filterOnKeyDown = (event) => {
  keyDownValue = event.target.value // Get the current value of the target

  if (!event.key) {
    return
  }

  const key = event.key.toLowerCase()
  const eventNames = ['backspace', 'delete', 'home', 'end', 'arrowup', 'arrowright', 'arrowdown', 'arrowleft', 'tab']

  // If the input isn't a number, an allowed symbol($ and .), or one of the standard input field 'navigation' keys, don't allow the key
  if (!(regex.test(key) || eventNames.includes(key))) {
    if (event.preventDefault) {
      event.preventDefault()
    }
  }
}

const filterOnInput = (event) => {
  inputValue = event.target.value // Get the current value of the target

  // Interestingly, on Android, if event.preventDefault is called in 'keydown', it still shows up on the screen, but doesn't get
  // reflected in the event.target.value.

  // So here, we're getting the difference between 'keydown' and 'input', giving us our entered character.
  const keyPress = difference(keyDownValue, inputValue)

  // If it's not a number or an allowed symbol($ or .), remove it from the input's value
  if (!(regex.test(keyPress))) {
    if (!isEmpty(event.target.value)) {
      event.target.value = `$${event.target.value.replace(/[^0-9.]+/g, '')}`
    }
  } else {
    if (event.data === '.') {
      const inputParts = event.target.value.split('.')
      if (inputParts.length > 1) {
        event.target.value = `$${inputParts[0]}.${inputParts[1].replace(/[^0-9]+/g, '')}`
      } else {
        event.target.value = `$${event.target.value.replace(/[^0-9.]+/g, '')}`
      }
    }
    event.target.value = `$${event.target.value.replace(/[^0-9.]+/g, '')}`
  }
}

const blurEvent = (event) => {
  if (!isEmpty(event.target.value)) {
    const parsedVal = Number.parseFloat(event.target.value.replace(/[,$]/g, ''))
    event.target.value = parsedVal.toString().indexOf('NaN') !== -1 || parsedVal === '$.' || parsedVal === '$' ? '' : `$${parsedVal.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
  }
}

const difference = (value1, value2) => {
  const output = []
  for (let i = 0; i < value2.length; i++) {
    if (value1[i] !== value2[i]) {
      output.push(value2[i])
    }
  }
  return output.join('')
}

export const InputCurrencyDirective = {
  bind (el) {
    // Set everything up
    el.addEventListener('keydown', filterOnKeyDown)
    el.addEventListener('input', filterOnInput)
    el.addEventListener('blur', blurEvent, true)
  },
  unbind (el) {
    // Clean up after ourselves
    el.removeEventListener('keydown', filterOnKeyDown)
    el.removeEventListener('input', filterOnInput)
    el.removeEventListener('blur', blurEvent, true)
  }
}
